import axios from "axios";

export const state = {
    servicecategories: [],
};

export const getters = {
    servicecategories: state => state.servicecategories,
};

export const mutations = {
    setServiceCategories(servicecategories, newValue) { state.servicecategories = newValue},
};

export const actions = {
    fetchServiceCategory({ commit }) {
        axios.get('/servicecategories').then(res => {
            commit('setServiceCategories', res.data.categories)
        })
    },
};
